import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { toast } from "sonner";

const HERO = "https://images.pexels.com/photos/16217479/pexels-photo-16217479.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/wardrobe");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-bg0">
      <div className="hidden md:block relative">
        <img src={HERO} alt="Streetwear" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-black/10" />
        <Link to="/" className="absolute top-8 left-8 flex items-center gap-3">
          <span className="w-3 h-3 bg-volt inline-block" />
          <span className="font-display uppercase text-xl tracking-tight">Eternal<span className="text-volt">/</span>Pairing</span>
        </Link>
      </div>

      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md ep-fade-up" data-testid="login-form">
          <div className="overline mb-4 text-volt">Welcome back</div>
          <h1 className="font-display uppercase text-5xl font-bold tracking-tighter mb-10">Sign in.</h1>

          {error && (
            <div className="mb-6 text-sm text-epred border border-epred px-4 py-3" data-testid="login-error">
              {error}
            </div>
          )}

          <label className="overline block mb-3">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            data-testid="login-email"
            className="w-full bg-transparent border-b-2 border-epborder focus:border-volt px-0 py-3 mb-7 text-white placeholder:text-zinc-600 transition-colors"
            placeholder="you@example.com"
          />

          <label className="overline block mb-3">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="login-password"
            className="w-full bg-transparent border-b-2 border-epborder focus:border-volt px-0 py-3 mb-9 text-white placeholder:text-zinc-600 transition-colors"
            placeholder="••••••••"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="ep-btn w-full bg-volt text-black py-4 text-sm font-bold uppercase tracking-widest hover:bg-volt-hover disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>

          <p className="text-sm text-epsub mt-8">
            New here?{" "}
            <Link to="/register" data-testid="goto-register" className="text-white font-semibold border-b border-volt">
              Create an account
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
